module.exports = __webpack_public_path__ + "img/horizontal_6_3_7016.96b28604.png";